<template>
  <div class="talent-price__wrapper">
    <div class="talent-price__container">
      <div class="talent-price__info">
        <p class="talent-price__info-subtitle">вартість</p>
        <h2 class="talent-price__info-title">
          ₴800/рік
          <span class="talent-price__info-color"
            ><br class="mobile-space" />(₴67/місяць)</span
          ><br /><span class="talent-price__info-thin">річна підписка</span>
        </h2>
      </div>
      <div class="talent-price__list">
        <div class="talent-price__list-item">
          <div class="talent-price__list-dot"></div>
          <p class="talent-price__list-text">
            Жодних комісій чи додаткових платежів з гонорарів
          </p>
        </div>
        <div class="talent-price__list-item">
          <div class="talent-price__list-dot"></div>
          <p class="talent-price__list-text">Просування в рекламному бізнесі</p>
        </div>
      </div>
      <div class="talent-price__bottom-wrapper">
        <a
          class="talent-price__bottom-link"
          href="https://docs.google.com/forms/d/e/1FAIpQLSeqH_MlJWDVN0OUicbCBT2CMPqYCCc5VqSzXFQw7Eds39FHWQ/viewform"
        >
          <div class="talent-price__bottom-button">Записатися на проби</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "talent-career-price-block",
}
</script>

<style lang="scss">
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Light.woff2") format("woff2");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Regular.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Medium.woff2") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Bold.woff2") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

.talent-price {
  &__wrapper {
    background-color: #fff5c5;
    width: 100%;
    padding: 60px 0;
  }
  &__container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 24px;
    @media (max-width: 700px) {
      padding: 0;
    }
  }
  &__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 24px;
    &-subtitle {
      font-size: 14px;
      font-weight: 500;
      padding-bottom: 20px;
      text-transform: uppercase;
      font-family: "Inter", sans-serif;
    }

    &-title {
      font-family: "Inter", sans-serif;

      font-size: 60px;
      line-height: 60px;
      font-weight: 500;
      color: #000000;
      letter-spacing: -0.02em;
      text-align: center;
      max-width: 845px;
      letter-spacing: -0.02em;
    }
    &-thin {
      font-size: 60px;
      line-height: 60px;
      font-weight: 300;
      text-align: center;
      max-width: 845px;
      letter-spacing: 0.02em;
      font-family: "Nyght Serif";
    }

    &-color {
      font-size: 60px;
      line-height: 60px;
      font-weight: 500;
      text-align: center;
      color: #989898;
      letter-spacing: -0.02em;
      font-family: "Inter", sans-serif;
    }
  }

  &__list {
    border-top: 1px solid #0000004d;
    border-bottom: 1px solid #0000004d;
    min-height: 45px;

    margin: 30px 0;

    display: flex;
    justify-content: center;
    column-gap: 50px;
    padding: 0 24px;
    flex-wrap: wrap;

    &-item {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    &-dot {
      width: 8px;
      min-width: 8px;
      height: 8px;
      border-radius: 8px;
      background-color: #7831f3;
    }

    &-text {
      font-size: 14px;
      color: #000000;
      font-weight: 500;
      font-family: "Inter", sans-serif;
      text-transform: uppercase;
    }
  }
  &__bottom {
    &-wrapper {
      display: flex;
      justify-content: center;
    }
    &-button {
      background-color: #fcc10f;

      display: flex;
      justify-content: center;
      align-items: center;

      width: 222px;
      height: 40px;
      font-family: "Inter", sans-serif;

      font-size: 14px;
      color: #000000;
      border-radius: 8px;
      text-transform: uppercase;
      font-weight: 600;
    }
  }
}
.mobile-space {
  display: none;
}
@media (max-width: 700px) {
  .talent-price {
    &__info {
      &-title {
        font-size: 36px;
        line-height: 36px;
      }
      &-thin {
        font-size: 36px;
        line-height: 36px;
      }
      &-color {
        font-size: 36px;
        line-height: 36px;
      }
    }
  }

  .mobile-space {
    display: block;
  }
}
@media (max-width: 500px) {
  .talent-price {
    &__list {
      gap: 12px 50px;
      padding: 14px 24px;
      justify-content: flex-start;
    }

    &__bottom {
      &-wrapper {
        width: 100%;
        padding: 0 24px;
      }
      &-button {
        width: 100%;
      }
      &-link {
        width: 100%;
      }
    }
  }
}
</style>
